import { useQuery } from "@tanstack/react-query"

import { whitelabels } from "@/services"

type UseWhiteLabelsOptions = {
  enabled?: boolean
}

const useWhiteLabels = (
  options?: UseWhiteLabelsOptions
) => {
  const { enabled = true } = options ?? {}

  return useQuery({
    queryKey: ["whitelabels"],
    queryFn: async () => {
      const response = await whitelabels()
      const updatedResponse = [
        {
          uuid: "",
          name: "Todas as lojas",
          slug: "Todas as lojas",
          colors: {
            lineBackground: "#ffffff",
            buttonActionBackground: "#ffffff",
            buttonActionText: "#ffffff",
          },
        },
        ...response,
      ]
      return updatedResponse
    },
    enabled,
  })
}
export default useWhiteLabels
